import React, { Component } from 'react';
import { Row, Col, Card, Icon, Button } from '$common';
import Translate from './translate';
import CSSModules from 'react-css-modules';
import style from './table.scss';
import cx from 'classnames';
import { fractions } from './constants';
import sum from 'lodash/sum';
import moment from 'moment';
import { browserHistory } from 'react-router';

let OSName = null;

@CSSModules(style, { allowMultiple: true })
export default class Table extends Component {
  
  static defaultProps = {
    showHeader: true,
    showAsCard: true
  };

  state = {
    showArrowRight: true,
    showArrowLeft: false,
    detailedIndexes: [],
    buttonLeft: 0,
    offsetWidth: 1000
  };

  scrollRight() {
    this.refs.container1.scrollLeft += 250;
    this.refs.container2.scrollLeft += 250;

    const scrollPosition = this.refs.container1.scrollLeft + this.refs.container1.getBoundingClientRect().width;
    if (Math.round(scrollPosition) >= this.refs.container1.scrollWidth) {
      this.setState({ showArrowRight: false });
    }

    this.state.buttonLeft += 250;

    this.setState({ offsetWidth: this.refs.container2.offsetWidth});
    this.setState({ showArrowLeft: true });
  }

  scrollLeft() {
    this.refs.container1.scrollLeft -= 250;
    this.refs.container2.scrollLeft -= 250;

    if (this.refs.container1.scrollLeft <= 0) {
      this.setState({ showArrowLeft: false });
    }

    this.state.buttonLeft -= 250;

    this.setState({ offsetWidth: this.refs.container2.offsetWidth});
    this.setState({ showArrowRight: true });
  }

  toggleDetails(index) {
    return () => {
      const { detailedIndexes } = this.state;

      if (detailedIndexes.includes(index)) {
        this.setState({ detailedIndexes: detailedIndexes.filter(i => i !== index) });
      } else {
        this.setState({ detailedIndexes: [...detailedIndexes, index] });
      }
    }
  }

  componentDidMount() {
    if (navigator.appVersion.indexOf("Win") !== -1) OSName = "Windows";
  }

  sort(column) {
    return () => {
      if (!column.sortable) return;

      const { onChangeOrder } = this.props;
      const direction = column.sortKey === this.currentSortKey && this.currentSortDirection === 'desc' ? 'asc' : 'desc';

      onChangeOrder(`${column.sortKey} ${direction}`);
    }
  }

  get currentSortKey() {
    const { currentOrder } = this.props;

    if (currentOrder) {
      return currentOrder.replace(/ asc| desc/gi, '');
    }
  }

  get currentSortDirection() {
    const { currentOrder } = this.props;

    if (currentOrder) {
      return currentOrder.match(/ desc$/) ? 'desc' : 'asc';
    }
  }

  render() {
    const { columns, detailedColumns, data, showHeader, showAsCard, rowClass, showRowDetailBtn, showRowDetailBtnClick } = this.props;
    const { showArrowLeft, showArrowRight, detailedIndexes } = this.state;

    if (typeof columns[0].isToggleButton === "undefined" && detailedColumns) {
      columns.unshift({
        isToggleButton: true,
        content: (item) => {
          return(
            <span styleName="expand-button" onClick={::this.toggleDetails(item.id)}>
              <Icon name={this.state.detailedIndexes.includes(item.id) ? 'caret-up' : 'caret-down'} />
            </span>
          )
        },
        width: '1/15'
      });
    }

    const total = sum(columns.map(i => parseInt(fractions[i.width].replace('%'))));

    const headerContent = columns.map((column, index) => {
      const percentage = parseInt(fractions[column.width].replace('%'));
      const width = percentage - (total - 100) / columns.length + '%';
      column.sortable = column.sortKey;

      const styleName = cx({
        'sortable-column': column.sortable,
        'current-order-column': column.sortable && column.sortKey === this.currentSortKey
      });

      const arrowDirection = column.sortKey === this.currentSortKey && this.currentSortDirection === 'asc' ? 'caret-up' : 'caret-down';
      return (
        <Col width={width} key={index}>
          <span styleName={styleName} onClick={this.sort(column).bind(this)}>
            {column.sortable ? <Icon name={arrowDirection} /> : null}{column.label}
          </span>
        </Col>
      )
    });

    let bodyContent = data.map((item) => {
      let columnData = columns.map((column, index) => {
        const percentage = parseInt(fractions[column.width].replace('%'));
        const width = percentage - (total - 100) / columns.length + '%';

        if (column.key) {
          var content = item[column.key];
        } else if (column.content) {
          var content = column.content(item);
        } else if(column.customColumnKey){
          var content = '';
          if (typeof item.task !== "undefined") {
            item.task.custom_fields.map(field => {
              if (field.key === column.customColumnKey) {
                content = field.value;
              }
            });
          } else {
            item.custom_fields.map(field => {
              if (field.key === column.customColumnKey) {
                content = field.value;
              }
            });
          }
        } else {
          var content = '';
        }

        if (column.type === 'date' && moment(content).isValid()) {
          content = moment(content).format(column.format || 'DD/MM/YYYY HH:mm');
        }

        column.style = { ...column.style, wordWrap: 'break-word'};

        if (OSName === 'Windows') {
          column.style = { ...column.style, color: '#888', fontWeight: '600' };
        } else {
          column.style = { ...column.style, color: 'rgba(0,0,0,.6)' };
        }

        return (
          <Col width={width} style={{ display: 'flex', flexDirection: 'column' }} key={index}>
            <div style={column.style} className={column.className ? column.className(item) : ''}>
              {content}
            </div>
          </Col>
        )
      });

      let contents = [];

      return [
        <Row styleName="body" className={rowClass ? rowClass(item) : ''} style={{position:'relative'}}>
          { showRowDetailBtn ? 
            <Button
              styleName="showDetail"
              style={{left:`${(this.state.offsetWidth/2)+this.state.buttonLeft}px`}}
              size="small"
              type="success"
              onClick={() => showRowDetailBtnClick(typeof item.project_id !== "undefined" ? item.project_id : item.projectId, item.id)}>
                {Translate.get('show_detail')}
              </Button>
          : null}
          {columnData}
        </Row>,
        detailedIndexes.includes(item.id) ? (
          <div styleName="row-details">
            <Row key="index">
              {
                Object.keys(detailedColumns).forEach((key, index) => {
                  var content = '';
                  if (typeof item.task !== "undefined") {
                    item.task.custom_fields.map(field => {
                      if (field.key === key) {
                        content = field.value;
                      }
                    });
                  }else{
                    item.custom_fields.map(field => {
                      if (field.key === key) {
                        content = field.value;
                      }
                    });
                  }
                  if (content) {
                    contents.push(
                      <Col md={detailedColumns[key].width} key={index}>
                        <b>{detailedColumns[key].label}</b>
                        {(content)}
                      </Col>
                    )
                  }
                })
              }
              {contents}
            </Row>
          </div>
        ) : null
      ];
    });

    if (showAsCard) {
      var _bodyComponent = Card;
    } else {
      var _bodyComponent = 'div';
    }

    return (
      <div
        className={this.props.className}
        styleName={`root ${process.muhimma.indexOf(process.target[0]) !== -1 ? 'muhimma' : ''}`}
        style={{ marginLeft:showArrowLeft && total > 100 ? '25px' : 0, marginRight:showArrowRight && total > 100 ? '25px' : 0}}
      >
        {showHeader ? (
          <div ref="container1" styleName="container">
            <div style={{ width: `${total}%` }}>
              <Row styleName="header">
                {headerContent}
              </Row>
            </div>
          </div>
        ) : null}
        {showArrowRight && total > 100 ? (
          <a styleName="arrow-right" onClick={::this.scrollRight}></a>
        ) : null}
        <_bodyComponent style={{ position: 'relative' }} id="tableBody">
          <div ref="container2" styleName="container">
            <div style={{ width: `${total}%` }}>
              {bodyContent}
            </div>
          </div>
        </_bodyComponent>
        {showArrowLeft && total > 100 ? (
          <a styleName="arrow-left" onClick={::this.scrollLeft}></a>
        ) : null}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/common/table.js